module.exports = __webpack_public_path__ + "img/45.22fc5763.jpg";